export const PosthogEventKeys = {
  PAGE_VIEW: '$pageview',
  // * your custom events
  LOGIN: 'login',
};
